export default __webpack_public_path__ + "static/media/contact.71ece7db.svg";